module.exports = __webpack_public_path__ + "img/shop.a2469346.png";